import { render, staticRenderFns } from "./emissionReduceSix.vue?vue&type=template&id=630036f6"
import script from "./emissionReduceSix.vue?vue&type=script&lang=js"
export * from "./emissionReduceSix.vue?vue&type=script&lang=js"
import style0 from "./emissionReduceSix.vue?vue&type=style&index=0&id=630036f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports